<template>
    <img :src="source" :onerror="getDefault()">
</template>

<script>
export default {
    props : {
        src : {
            type : String
        },
        s3 : {
            type : Boolean,
            default : true
        },
        defaultAsset : {
            type : String,
            default : 'mexico/general_assets/thumbgenericorecurso.jpg'
        }
    },
    methods : {
        getDefault() {
            return "this.src='"+(this.s3 ? this.$options.filters.s3url(this.defaultAsset) : this.defaultAsset)+"'";
        }
    },
    computed : {
        source() {
            return this.s3 ? this.$options.filters.s3url(this.src) : this.src;
        }
    }
}
</script>

